export default function SectionPlaceholder({ height = "320px" }) {
  return (
    <div
      className="w-full animate-pulse bg-brand-navy/30 rounded-none"
      style={{ minHeight: height }}
      aria-hidden
    />
  );
}
